//shared containers
import { Footer } from '@/containers-m/Footer';
import { Navigation } from '/containers-m/';
import { Logos, logos_list } from '@/containers-ai/Logos';

import { Proof, proofOutcomes } from '@/containers-ai/Proof';

//containers
import {
  Hero,
  LifecycleRail,
  EndCTA,
  FreightExperts,
  AICompounding,
  Rails,
} from './containers/index';

//styles
import { PageWrapper, HomeGlobalStyle } from './Home.styles';

function Home() {
  return (
    <PageWrapper>
      <HomeGlobalStyle />
      <Navigation theme="dark" />
      <Hero />
      <Logos logos={logos_list} label={false} />
      <LifecycleRail />
      <EndCTA variant="top" />
      <FreightExperts />
      <AICompounding />
      <Proof outcomes={proofOutcomes} />
      <Rails />
      <EndCTA variant="bottom" />
      <Footer />
    </PageWrapper>
  );
}

export default Home;
export { Home };
